import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import SmoothScrollProvider from "@/components/SmoothScrollProvider";
import ScrollProgress from "@/components/ScrollProgress";
import Home from "@/pages/Home";
import Brands from "@/pages/Brands";
import Creators from "@/pages/Creators";
import UGC from "@/pages/UGC";
import Agency from "@/pages/Agency";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ComingSoon from "@/pages/ComingSoon";
import PolicyPage from "@/pages/PolicyPage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <SmoothScrollProvider>
          <ScrollToTop />
          <ScrollProgress />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/creators" element={<Creators />} />
              <Route path="/ugc" element={<UGC />} />
              <Route path="/agency" element={<Agency />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/coming-soon" element={<ComingSoon />} />
              <Route path="/privacy" element={<PolicyPage slug="privacy" />} />
              <Route path="/terms" element={<PolicyPage slug="terms" />} />
              <Route path="/refund" element={<PolicyPage slug="refund" />} />
              <Route path="/cookies" element={<PolicyPage slug="cookies" />} />
              <Route path="/disclaimer" element={<PolicyPage slug="disclaimer" />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScrollProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
